/**
 * Created by asiulik on 09.06.2017.
 */

define(['lodash', 'eventEmitter/EventEmitter'], function (_, EventEmitter) {

    var youtubeVideoInited = false;
    var youtubeApiReady = false;

    const playBtn = document.querySelector(("[data-local-play-btn]"));
    const localVideo = document.querySelector(("[data-local-video]"));

    if (playBtn) {
        playBtn.addEventListener("click", playLocalVideo);
    }

    function playLocalVideo() {
        playBtn.remove();
        localVideo.play();
    }

    function YoutubeVideo(videoId, videoContainer) {

        this.videoSrc = "https://www.youtube.com/embed/" + videoId + "?controls=2&rel=0&autoplay=1";
        this.videoIframe = videoContainer.find("#videoIframeYoutubeContent");

        this.createPlayer();
    }

    YoutubeVideo.prototype = _.clone(EventEmitter.prototype);

    YoutubeVideo.prototype.createPlayer = function () {

        var _this = this;
        _this.initPlayer();

    };

    YoutubeVideo.prototype.clearPlayer = function () {

        this.videoIframe.removeAttr("src");

    };

    YoutubeVideo.prototype.initPlayer = function () {
        this.videoIframe.attr("src", this.videoSrc);
    };

    YoutubeVideo.prototype.playVideo = function (playerInstance) {
        this.videoIframe.attr("src", this.videoSrc);
    };

    YoutubeVideo.prototype.pauseVideo = function (playerInstance) {
        this.videoIframe.removeAttr("src");
    };

    YoutubeVideo.prototype.getPlayer = function () {
        if(!this.player) this.initPlayer();
        return this.player;
    };

    return YoutubeVideo;


});



// WEBPACK FOOTER //
// ./Private/Scripts/core/video.js